import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import defaultStyles from './DropToolBar.module.css';
import jlrStyles from './DropToolBarJlr.module.css';
import { DatePicker } from '..';
import { Prompt } from 'react-router-dom';
import { DISPLAY_MESSAGES } from '../../constants';
import { Switch, FormControlLabel, withStyles } from '@material-ui/core';
import '../../cssModules/switch.css';
import {
  callFunctionConditionallyWithWarningCurry,
  setStylesAccordingToPlant,
} from '../../utils/utils';
import DropScreenLineDropDownSelector from '../LineDropdownSelector/DropScreenLineDropDownSelector';
import AggregateLineDropDownSelector from '../LineDropdownSelector/AggregateLineDropDownSelector';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';

const BlueSwitch = withStyles({
  switchBase: {
    '&$checked': {
      '& $thumb': {
        backgroundColor: '#2196f3 !important',
      },
    },
    '&$checked + $track': {
      backgroundColor: '#2196f3 !important',
      opacity: 0.5,
      border: 'none !important',
    },
  },
  thumb: {},
  track: {},
  checked: {},
})(Switch);

const DropToolbar = ({
  restrictNavigationDuringEditing,
  hasActiveEdits,
  activeDate,
  dates,
  handleDateSelect,
  lastRefreshedDate,
  contextualButtonProps = {},
  showAggregateLines = false,
  isPrintingEnabled,
  setIsPrintingEnabled,
  showPrintingToggle,
}) => {
  const [plant] = usePlantAndLinesStore().plantState;
  const [styles, setStyles] = useState(defaultStyles);

  useEffect(() => {
    setStylesAccordingToPlant(plant, setStyles, defaultStyles, jlrStyles);
  }, [plant]);

  return (
    <div className={styles.RgtTools}>
      <span className={styles.captionSmallBt}>
        {lastRefreshedDate
          ? `Last Refreshed: ${lastRefreshedDate.format(
            'hh:mmA [(IST)] DD MMMM YYYY',
          )}`
          : 'Last Refreshed: --:--'}
      </span>
      <div className={styles.aggregateToolbar}>
        <div className={styles.datesSelectorBar}>
          <DatePicker
            startDate={moment()}
            endDate={dates[dates.length - 1]}
            activeDate={activeDate}
            handleSelectedDate={callFunctionConditionallyWithWarningCurry(
              handleDateSelect,
              hasActiveEdits,
            )}
            handlePreviousDate={callFunctionConditionallyWithWarningCurry(
              contextualButtonProps.handleClick,
              hasActiveEdits,
            )}
            buttonTitle={contextualButtonProps.text}
          />
        </div>

        {showPrintingToggle && setIsPrintingEnabled && (
          <div className={styles.printingToggleContainer}>
            <FormControlLabel
              control={
                <BlueSwitch
                  checked={isPrintingEnabled}
                  onChange={(e) => setIsPrintingEnabled(e.target.checked)}
                  name="printingToggle"
                  color="primary"
                  size="small"
                />
              }
              label={<span className={styles.printingLabel}>Enable Print</span>}
              style={{ marginRight: 0, marginLeft: 0 }}
            />
          </div>
        )}

        <div className={styles.lineSelect}>
          <div className={styles.selectorSmall}>
            <span className={styles.captionSmall}>Select Line</span>
          </div>
          <div className={styles.selectorBt}>
            {showAggregateLines ? (
              <AggregateLineDropDownSelector hasActiveEdits={hasActiveEdits} />
            ) : (
              <DropScreenLineDropDownSelector hasActiveEdits={hasActiveEdits} />
            )}
          </div>
        </div>
      </div>
      {restrictNavigationDuringEditing && (
        <Prompt
          when={hasActiveEdits}
          message={() => DISPLAY_MESSAGES.NAVIGATION_WARNING}
        />
      )}
    </div>
  );
};
DropToolbar.propTypes = {
  restrictNavigationDuringEditing: PropTypes.bool.isRequired,
  hasActiveEdits: PropTypes.bool.isRequired,
  activeDate: PropTypes.objectOf(moment),
  dates: PropTypes.arrayOf(PropTypes.objectOf(moment)),
  handleDateSelect: PropTypes.func.isRequired,
  lastRefreshedDate: PropTypes.objectOf(moment),
  contextualButtonProps: PropTypes.shape({
    label: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
    handleClick: PropTypes.func.isRequired,
  }),
  isPrintingEnabled: PropTypes.bool,
  setIsPrintingEnabled: PropTypes.func,
  showPrintingToggle: PropTypes.bool,
};

export default DropToolbar;
